import React from "react";
import "./styles.scss";

interface ProgressBarProps {
  progress: number;
  colorProgressBar?: string;
  colorContainerProgressBar?: string;
}

function ProgressBar({
  progress,
  colorContainerProgressBar,
  colorProgressBar,
}: ProgressBarProps) {
  const formattedProgressPercent = `${Math.ceil(progress)}%`;

  return (
    <div
      className="progressBarContainer"
      style={{
        backgroundColor: colorContainerProgressBar,
      }}
    >
      <div
        className="progressBarContent"
        style={{
          width: `${formattedProgressPercent}`,
          backgroundColor: colorProgressBar,
        }}
      />
    </div>
  );
}

export { ProgressBar };
